
import { PATH_TO_WIDTH_PROPERTY } from "@/lib/columns/helpers";
import { documentStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import lodash from "lodash";
import { COLUMN_SLUG } from "@/lib/elements/constants";
import { openUiPanel } from "@/lib/panels/panels";
import { breakdanceUndo } from "@/lib/undo/undo";
import { rewidthColumnsAndCommitToStore } from "@/lib/columns/rewidthing";
import { parseFloatAndFixTo2Digits } from "@/util/math";

@Component({})
export default class EmptyColumns extends Vue {
  @Prop()
  id!: number;

  addColumns(e: Event, numberOfColumns: number, columnWidths?: number[]) {
    // Don't open links if inside an `a`
    e.preventDefault();
    e.stopPropagation();

    const nodes: TreeNode[] = [];
    const columnProperties = columnWidths
      ? columnWidths.map(columnWidth => {
          const columnWidthSanitized = parseFloatAndFixTo2Digits(columnWidth);

          return lodash.set({}, PATH_TO_WIDTH_PROPERTY, {
            number: columnWidthSanitized,
            unit: "%",
            style: `${columnWidthSanitized}%`
          });
        })
      : []; // rewidthColumnsAndCommitToStore will do all the math necessary for the columns when they're equal

    for (let i = 0; i < numberOfColumns; i++) {
      nodes.push({
        id: i,
        data: {
          type: COLUMN_SLUG,
          properties: columnWidths ? columnProperties[i] : {}
        },
        children: []
      });
    }

    breakdanceUndo.transaction(() => {
      documentStore.addMultipleNodes({
        nodes: nodes,
        parentId: this.id
      });

      if (!columnWidths) {
        rewidthColumnsAndCommitToStore(this.id);
      }
    }, `Set amount of columns to ${numberOfColumns}`);

    openUiPanel("elementproperties");
  }
}
